import { Common } from '@thecvlb/design-system/lib/src';

import { BasicSignupStepProps } from 'containers/SignUp/Content/content.types';

import fop from 'assets/images/signUp/fop.webp';
import fopTwo from 'assets/images/signUp/fop-2.webp';

const BlueLineIntro: React.FC<BasicSignupStepProps> = ({ moveToStep }) => {
  const logoClassName = 'size-10 md:size-8';

  return (
    <div className="onboarding-page-wrapper">
      <div className="flex items-center justify-center gap-6">
        <Common.Logo className={logoClassName} name="cross" />
        <Common.Icon name="close" />
        <div className="flex items-center gap-2">
          <img className={logoClassName} src={fop} />
          <img className={logoClassName} src={fopTwo} />
        </div>
      </div>
      <div className="flex flex-col items-center gap-2 text-primary-700">
        <h3 className="wm-signup-title text-center">Welcome to LifeMD!</h3>
        <span className="text-center">
          LifeMD is pleased to offer <span className="font-bold">Thin Blue Line Benefits</span>{' '}
          members access to a discounted weight management program. Let’s get trimmer and Blue Line
          thin(ner) together!
        </span>
      </div>
      <Common.Button
        className="max-md:mt-auto md:mx-auto"
        color="blue"
        fullWidthOnMobile
        onClick={() => moveToStep('next')}
      >
        Continue
      </Common.Button>
    </div>
  );
};

export default BlueLineIntro;
